import mapActions from './mapActions';

export default mapActions('building_issue_states');